

































































import { DateTime } from 'luxon';
import { mapGetters } from 'vuex';

import { getUserGameTransactions } from '@/api/Transaction';

import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';

import formatDate from '@/helpers/formatDate';
import { textOverflowMiddle } from '@/helpers/formatString';
import { copyToClipBoard } from '@/helpers/copyToClipBoard';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { getLinkToGameTransaction } from '@/helpers/explorerHelper';

export default {
  name: 'UserManagementGameTransactionsTab',
  components: {
    VExtendedDataPicker
  },
  props: {
    userId: {
      type: Number
    }
  },
  data(): any {
    return {
      isLoading: false,
      selectedDate: DateTime.now().toFormat('yyyy-LL-dd'),
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['amount'],
        sortDesc: [true]
      },
      tableItems: [],
      hasNext: false
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    itemsLength(): number {
      return (
        this.tableOptions.page * this.tableOptions.itemsPerPage +
        (this.hasNext ? 1 : 0)
      );
    },
    tableHeaders(): { [key: string]: string | boolean }[] {
      return [
        {
          text: 'Date',
          value: 'date',
          width: '150px',
          sortable: false
        },
        {
          text: 'Type',
          value: 'actionType',
          width: '20%',
          sortable: false
        },
        {
          text: 'Amount',
          value: 'amount',
          width: '20%',
          sortable: true
        },
        {
          text: 'Play to Earn Reward',
          value: 'reward',
          width: '20%',
          sortable: false
        },
        {
          text: 'Transaction ID',
          value: 'hash',
          width: '20%',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          width: '20%',
          sortable: false
        }
      ];
    }
  },

  watch: {
    operatorId: {
      handler: 'fetchTransactions'
    }
  },

  methods: {
    textOverflowMiddle,
    copyToClipBoard,
    getLinkToGameTransaction,
    getFormatDate(date: string): string {
      return formatDate(
        date.slice(0, date.lastIndexOf('.')),
        'yy.MM.dd HH:mm',
        true,
        false
      );
    },
    async fetchTransactions(): Promise<void> {
      try {
        this.isLoading = true;

        const { gameActions, hasNext } = await getUserGameTransactions(
          this.userId,
          {
            size: this.tableOptions.itemsPerPage,
            page: this.tableOptions.page - 1,
            sort: this.tableOptions.sortBy[0],
            order: this.tableOptions.sortDesc[0] ? 'desc' : 'asc',
            date: this.selectedDate
          }
        );

        this.tableItems = gameActions;
        this.hasNext = hasNext;
      } catch (error) {
        this.tableItems = [];
        this.hasNext = false;

        errorToastMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleOnDateChange(date: string): void {
      this.selectedDate = date;
      this.fetchTransactions();
    }
  }
};
